import React, { useCallback, useEffect, useState, useRef } from "react";
import { Row, Col } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import Pagination from "../../../../../ui/Pagination";
import SkeletonLoader from "../../../../../ui/SkeletonLoader";
import NoDataFound from "../../../../../ui/NoDataFound";
import SideModal from "../../../../../ui/SideModal";
// import CustomTooltip from "../../../../../ui/Tooltip";

import DownloadReport from "../../../Reports/DownloadReport";

import { searchIcon, trendingDownIcon, trendingUpIcon, credentialsOpenIcon, tableSortArrowIcon } from "../../../../../../utils/icons";
import { formatDate, formatNumber } from "../../../../../../utils/util";

import { useSelector, useDispatch } from 'react-redux';
import { getVendorOverview, resetVendorOverview } from "../../../../../../store/actions/thirdPartyRiskAction";

const VendorOverview = ({customerId}) => {

    const vendorOverviewListResponse = useSelector((state) => state.thirdPartyRisk.vendorOverviewList);
    
    const prevCustomerIdRef = useRef(null);
    
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [searchValue, setSearchValue] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);

    const [vendorOverviewList, setVendorOverviewList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [paginatedData, setPaginatedData] = useState([]);
    const [sortColumn, setSortColumn] = useState(null);
    const [sortDirection, setSortDirection] = useState("asc");

    const [showAddOrgSidePanel, setShowAddOrgSidePanel] = useState(false);

    const closeAddOrgSidePanel = () => {
        setShowAddOrgSidePanel(false)
    }

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const handleSort = (columnKey) => {
        if (sortColumn === columnKey) {
            // Toggle direction
            setSortDirection(prev => (prev === "asc" ? "desc" : "asc"));
        } else {
            // New column, default to ascending
            setSortColumn(columnKey);
            setSortDirection("asc");
        }
    };

    const extractValue = (obj, key) => {
        const keyMap = {
            score: obj?.stats?.overall_score?.overall_score || 0,
            trend: obj?.stats?.overall_score?.percentage || 0,
            impact: obj?.stats?.overall_score?.risk_level || "",
            assets: obj?.stats?.digital_asset_count || 0,
            footprint: obj?.stats?.digital_footprint_count || 0,
            indicator: obj?.stats?.compromised_indicator_count || 0
        };
    
        return keyMap[key] !== undefined ? keyMap[key] : obj?.[key] || "";
    };

    const fetchVendorOverview = useCallback(()=>{
        setIsLoading(true)
        dispatch(getVendorOverview(customerId))
    },[customerId, dispatch])

    useEffect(() => {
        let filtered = [...vendorOverviewList];

        if (searchValue.trim()) {
            filtered = filtered.filter((org) =>
                org.name.toLowerCase().includes(searchValue.toLowerCase())
            );
        }

        if (sortColumn) {
            filtered.sort((a, b) => {
                const aVal = extractValue(a, sortColumn);
                const bVal = extractValue(b, sortColumn);
    
                if (typeof aVal === "string") {
                    return sortDirection === "asc"
                        ? aVal.localeCompare(bVal)
                        : bVal.localeCompare(aVal);
                } else {
                    return sortDirection === "asc"
                        ? aVal - bVal
                        : bVal - aVal;
                }
            });
        }

        const startIndex = (currentPage - 1) * currentPageSize;
        const endIndex = startIndex + currentPageSize;
        setPaginatedData(filtered.slice(startIndex, endIndex));

    }, [vendorOverviewList, searchValue, currentPage, currentPageSize, sortColumn, sortDirection]);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchValue]);

    useEffect(()=>{
        if(customerId !== prevCustomerIdRef.current) {
            fetchVendorOverview();
            prevCustomerIdRef.current = customerId;
        }
    },[customerId, fetchVendorOverview])

    useEffect(()=>{
        if(vendorOverviewListResponse !== null) {
            const orgs = vendorOverviewListResponse?.stats?.organizations;
            setVendorOverviewList(orgs);
            dispatch(resetVendorOverview())
            setIsLoading(false)
        }
    },[vendorOverviewListResponse, dispatch])
    
    return (
        <Row>
            <Col lg={12}>
                <div className="git-leaks-main-content third-party-overview bg-white-with-shadow p-4 mt-4">
                    <p className="heading-text mb-3">Third-Party Vendors Overview</p>
                    <div className="search-header-container d-flex align-items-center gap-3">
                        <div className="d-flex gap-3">
                            <div className="search-container position-relative">
                                <span className="position-absolute">{searchIcon()}</span>
                                <input type="text" 
                                    placeholder="Search" 
                                    value={searchValue} 
                                    onChange={(e)=>setSearchValue(e.target.value)} />
                            </div>
                            {/* <button className="search-btn">Search</button> */}
                        </div>                    
                        {/* <div className="position-relative">
                            <span className="filter-icon">{filterIcon()}</span>
                            {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                            {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                                <h6>New Findings</h6>
                                <div className="filter-user-status d-flex mb-4 gap-4">
                                    {
                                        newFindingsOption.map((data,index)=>{
                                            return (
                                                <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setNewFindingsType(value)}} key={index} isChecked={data.value === newFindingsType} />
                                            )
                                        })
                                    }
                                </div>
                                {getloggedInUserType() === "internal" && <>
                                    <h6>False Positive</h6>
                                    <div className="filter-user-status d-flex mb-4 gap-4">
                                        {
                                            newFindingsOption.map((data,index)=>{
                                                return (
                                                    <RadioButton radioId={`false-positive-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setSelectedFalsePositive(value)}} key={index} isChecked={data.value === selectedFalsePositive} />
                                                )
                                            })
                                        }
                                    </div>
                                </>}                            
                                <h6>Status</h6>
                                <div className="filter-user-status d-flex mb-4 gap-4">
                                    {
                                        statusOption.map((data,index)=>{
                                            return (
                                                <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setStatusSelected(value)}} key={index} isChecked={data.value === statusSelected} />
                                            )
                                        })
                                    }
                                </div>
                                <div className="filter-apply-btn mt-3">
                                    <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={newFindingsType === "" && statusSelected === "" && selectedFalsePositive === ""} buttonClicked={()=>{applyFilter()}}/>
                                </div>
                            </div>}
                        </div> */}
                    </div>
                    <div className="table-container js-secrets-table vendor-overview-table mt-3">
                        {
                            isLoading ?
                            <SkeletonLoader type={"line"} count={5} currentPage={"dashboardOverview"} />
                            :
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Vendor</th>
                                        <th><p className="d-flex align-items-center cursor-pointer gap-1"><span className="d-inline-block cursor-pointer" onClick={() => handleSort("score")}>Score</span><span className="d-inline-block">{tableSortArrowIcon()}</span></p></th>
                                        <th><p className="d-flex align-items-center cursor-pointer gap-1"><span className="d-inline-block cursor-pointer" onClick={() => handleSort("trend")}>Trend</span><span className="d-inline-block">{tableSortArrowIcon()}</span></p></th>
                                        <th><p className="d-flex align-items-center cursor-pointer gap-1"><span className="d-inline-block cursor-pointer" onClick={() => handleSort("impact")}>Business Impact</span><span className="d-inline-block">{tableSortArrowIcon()}</span></p></th>
                                        {/* <th>Vendor Status</th> */}
                                        <th><p className="d-flex align-items-center cursor-pointer gap-1"><span className="d-inline-block cursor-pointer" onClick={() => handleSort("assets")}>Digital Asset</span><span className="d-inline-block">{tableSortArrowIcon()}</span></p></th>
                                        <th><p className="d-flex align-items-center cursor-pointer gap-1"><span className="d-inline-block cursor-pointer" onClick={() => handleSort("footprint")}>Digital Footprint</span><span className="d-inline-block">{tableSortArrowIcon()}</span></p></th>
                                        <th><p className="d-flex align-items-center cursor-pointer gap-1"><span className="d-inline-block cursor-pointer" onClick={() => handleSort("indicator")}>Compromise Indicator</span><span className="d-inline-block">{tableSortArrowIcon()}</span></p></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        paginatedData.length > 0 &&
                                        paginatedData.map((data, index)=>{
                                            return (
                                                <motion.tr
                                                    key={index}
                                                    initial={{ opacity: 0, y: 20 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                                >
                                                    <td className="vendor-details">
                                                        <p className="vendor-name">{data?.name}</p>
                                                        <p className="vendor-date">Added on {formatDate(data?.created_at, "date")}</p>
                                                    </td>
                                                    <td className="score-details">
                                                        {data?.stats?.overall_score?.obtained_score}
                                                    </td>
                                                    <td className="trend-details">
                                                        {data?.stats?.overall_score?.percentage} <span>{data?.stats?.overall_score?.trend === "decreased" ? trendingDownIcon() : trendingUpIcon()}</span>
                                                    </td>
                                                    <td className="impact-details">
                                                        {data?.stats?.overall_score?.risk_level}
                                                    </td>
                                                    {/* <td className="status-container">
                                                        <p className="status closed">Live</p>
                                                    </td> */}
                                                    <td className="asset-details">
                                                        {formatNumber(data?.stats?.digital_asset_count)}
                                                    </td>
                                                    <td className="footprint-details">
                                                        {formatNumber(data?.stats?.digital_footprint_count)}
                                                    </td>
                                                    <td className="compromise-details">
                                                        {formatNumber(data?.stats?.compromised_indicator_count)}
                                                    </td>
                                                    <td className="action-details">
                                                        <div className="overview-options d-flex gap-2">
                                                            <p className="view cursor-pointer" onClick={()=>{
                                                                navigate(`/scan-info/third-party/vendor-risk-profile?customer=${customerId}&organization=${data?.organization_id}&domain=all&scanId=null`)
                                                            }}>View {credentialsOpenIcon()}</p>
                                                            {/* <p className="border-right"></p>
                                                            <p className="cursor-pointer" onClick={()=>setShowAddOrgSidePanel(true)}>
                                                                {downloadIcon()}
                                                            </p> */}
                                                            {/* <p className="border-right"></p>
                                                            <p className="cursor-pointer">{editIcon()}</p> */}
                                                        </div>
                                                    </td>
                                                </motion.tr>
                                            )
                                        })
                                    }                                    
                                </tbody>
                            </Table>
                        }
                        <SideModal showSidePanel={showAddOrgSidePanel} hideSidePanel={closeAddOrgSidePanel}>
                            {showAddOrgSidePanel && <DownloadReport currentPageType={"header"} closeDownloadReport={closeAddOrgSidePanel}/>}
                        </SideModal>
                        {!isLoading && vendorOverviewList?.length > 0 && <Pagination
                            className="pagination-bar"
                            currentPage={currentPage}
                            pageSize={currentPageSize}
                            totalCount={
                                searchValue.trim()
                                    ? vendorOverviewList.filter(org => org.name.toLowerCase().includes(searchValue.toLowerCase())).length
                                    : vendorOverviewList.length
                            }
                            onPageChange={setCurrentPageandRecordSize}
                        />}

                        {!isLoading && vendorOverviewList?.length === 0 && 
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <NoDataFound noDataText={"No Record Found"}/>
                            </motion.div>
                        }
                    </div>
                </div>
            </Col>
        </Row>
    )
}

export default VendorOverview;